/* eslint  max-classes-per-file: 0 */ // --> OFF
export class DatePickerEx extends kendo.ui.DatePicker {
    value(value) {
        if (typeof (value) === "string") {
            const date = new Date(value);
            // Checks if the original string really was a Date.toString() value
            if (!Number.isNaN(date.valueOf()) && date.toString() === value) {
                return super.value(date);
            }
        }
        return super.value(value);
    }
}
// Create an alias of the prototype (required by kendo.ui.plugin)
DatePickerEx.fn = DatePickerEx.prototype;
// Deep clone the widget default options
DatePickerEx.fn.options = $.extend(true, {}, kendo.ui.DatePicker.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
DatePickerEx.fn.options.name = "DatePickerEx";
// Create a jQuery plugin.
kendo.ui.plugin(DatePickerEx);
export class DateTimePickerEx extends kendo.ui.DateTimePicker {
    value(value) {
        if (typeof (value) === "string") {
            const date = new Date(value);
            // Checks if the original string really was a Date.toString() value
            if (!Number.isNaN(date.valueOf()) && date.toString() === value) {
                return super.value(date);
            }
        }
        return super.value(value);
    }
}
// Create an alias of the prototype (required by kendo.ui.plugin)
DateTimePickerEx.fn = DateTimePickerEx.prototype;
// Deep clone the widget default options
DateTimePickerEx.fn.options = $.extend(true, {}, kendo.ui.DateTimePicker.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
DateTimePickerEx.fn.options.name = "DateTimePickerEx";
// Create a jQuery plugin.
kendo.ui.plugin(DateTimePickerEx);
export class YearlessDatePicker extends kendo.ui.DatePicker {
    constructor(element, options) {
        super(element, options);
        const that = this; // eslint-disable-line
        const dateView = that.dateView;
        that._update = this.updateEx; //eslint-disable-line
        dateView._calendar(); //eslint-disable-line
        dateView.baseOpen = dateView.open;
        dateView.calendar.baseNavigate = dateView.calendar.navigate;
        dateView.calendar.baseNavigateUp = dateView.calendar.navigateUp;
        dateView.open = this.open;
        dateView.calendar.navigate = this.navigate;
        dateView.calendar.navigateUp = this.navigateUp;
        dateView.calendar.setTitle = this.setTitle;
    }
    // Function override to set year to 400
    updateEx(value) {
        const that = this; // eslint-disable-line
        const current = that._value; //eslint-disable-line
        let date = kendo.parseDate(value, that.options.parseFormats, that.options.culture);
        if (date) {
            date.setFullYear(400);
        }
        const isSameType = (date === null && current === null) || (date instanceof Date && current instanceof Date);
        let formattedValue;
        if (that.options.disableDates(date)) {
            date = null;
            if (!that._old && !that.element.val()) { //eslint-disable-line
                value = null; //eslint-disable-line
            }
        }
        if (+date === +current && isSameType) {
            formattedValue = kendo.toString(date, that.options.format, that.options.culture);
            if (formattedValue !== value) {
                that.element.val(date === null ? value : formattedValue);
            }
            return date;
        }
        that._value = date; // eslint-disable-line
        that.dateView.value(date);
        that.element.val(kendo.toString(date || value, that.options.format, that.options.culture));
        that._updateARIA(date); //eslint-disable-line
        return date;
    }
    open() {
        const that = this; // eslint-disable-line
        that.baseOpen();
        that.calendar.setTitle(that.calendar._current); //  eslint-disable-line
    }
    navigate(value, view) {
        const that = this; // eslint-disable-line
        that.baseNavigate(value, view);
        that.setTitle(value || that._value); // eslint-disable-line
    }
    navigateUp() {
        const that = this; // eslint-disable-line
        if (that.view().name === "month") {
            that.baseNavigateUp();
        }
    }
    setTitle(value) {
        const that = this; // eslint-disable-line
        if (that.view().name === "month") {
            that._title.html((kendo.cultures[that.options.culture] || kendo.cultures.current).calendar.months.names[value.getMonth()]); // eslint-disable-line
        }
        else if (that.view().name === "year") {
            that._title.html(TextResources.Views_Monate); // eslint-disable-line
        }
    }
}
// Create an alias of the prototype (required by kendo.ui.plugin)
YearlessDatePicker.fn = YearlessDatePicker.prototype;
// Deep clone the widget default options
YearlessDatePicker.fn.options = $.extend(true, {}, kendo.ui.DatePicker.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
YearlessDatePicker.fn.options.name = "YearlessDatePicker";
// Create a jQuery plugin.
kendo.ui.plugin(YearlessDatePicker);
